import { type Component as VueComponent } from "vue";
import { Prop, Component, toNative } from "vue-facing-decorator";
import { BufferedBase } from "./BufferedBase";
import { type IConversions } from "./IConversions";

export type WithOptionalImplicitFields<T> = T & {
	// An explicit override for the component to use to render this item of the list.
	Component?: string | VueComponent
};

/*
 * A conversion of a list element id to the actual data that is used to render
 * the list item.
 *
 * This class augments such a simple mapping with the buffering of the
 * IBuffered interface.
 */
@Component
export class BufferedConversion<S, T> extends BufferedBase<WithOptionalImplicitFields<T>> {
	@Prop({ required: true }) protected readonly from!: S;
	@Prop({ required: true }) protected readonly conversions!: IConversions<S, WithOptionalImplicitFields<T>>;

	protected getFromBackend(): WithOptionalImplicitFields<T> {
		return this.conversions.data(this.from);
	}

	protected loadInBackend(): Promise<void> {
		return this.conversions.load([this.from]);
	}

	protected invalidateInBackend(): Promise<void> {
		return this.conversions.invalidate(this.from);
	}

	protected isBackendResetting(): number {
		return this.conversions.isResetting;
	}
}

export default toNative(BufferedConversion);
